import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { AppScreenTitle, FormUserProfile } from "@/components/common";
import { ChangeAvatarForm, ChangePasswordDialog } from "./components";
import { useChangePassword, useProfile, useUpdateProfile } from "./hooks";
import { ProfileContainer } from "./Profile.style";

const ProfilePage = () => {
  const { t: getLabel } = useTranslation();

  const { profile, avatar } = useProfile();
  const { changeAvatar, updateProfile } = useUpdateProfile();
  const { changePasswordStatus, changePassword } = useChangePassword();

  const [isOpenDialog, setIsOpenDialog] = useState(false);

  const handleToggleOpenPasswordDialog = () => {
    setIsOpenDialog(!isOpenDialog);
  };

  useEffect(() => {
    if (changePasswordStatus === "success") {
      setIsOpenDialog(false);
    }
  }, [changePasswordStatus]);

  return (
    <Box>
      <AppScreenTitle>{getLabel("L_PROFILE")}</AppScreenTitle>
      <ProfileContainer>
        <ChangeAvatarForm avatar={avatar} userName={profile.name} onChange={file => changeAvatar(profile, file)} />
        <FormUserProfile
          profile={profile}
          onSubmit={updateProfile}
          buttonPrimaryLabel={getLabel("L_UPDATE")}
          ButtonSecondaryProps={{
            children: getLabel("L_CHANGE_PASSWORD"),
            onClick: handleToggleOpenPasswordDialog,
          }}
          isProfile
        />
      </ProfileContainer>
      <ChangePasswordDialog
        open={isOpenDialog}
        onClose={handleToggleOpenPasswordDialog}
        onChangePassword={changePassword}
      />
    </Box>
  );
};

export default ProfilePage;
